// First message sent back by the server (ex: "username already taken"), or the fallback.
const getErrorMessage = (error: any, fallback: string) => {
  if (error && error.graphQLErrors && error.graphQLErrors.length && error.graphQLErrors[0].message) {
    return error.graphQLErrors[0].message as string;
  }
  return fallback;
};

export { getErrorMessage };
